module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('tabs', {
    attrs: {
      "nav-style": "tabs"
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('tab', {
    attrs: {
      "header": "Investigation Summary"
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('investigationHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation),
      expression: "investigation"
    }],
    attrs: {
      "investigation": _vm.investigation,
      "invMigrationRefs": _vm.invMigrationRefs
    }
  }), _vm._v(" "), _c('undertakingHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation && !_vm.isConsultantOnly),
      expression: "investigation && !isConsultantOnly"
    }],
    attrs: {
      "undertaking": _vm.undertaking
    }
  }), _vm._v(" "), (_vm.investigationLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.isShpo && _vm.isPendingQaqc) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('label', {
    staticClass: "control-label text-label",
    attrs: {
      "for": "isBacklog"
    }
  }, [_vm._v("Back Log")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isBacklogSelect),
      expression: "isBacklogSelect"
    }],
    staticClass: "form-check-input",
    staticStyle: {
      "width": "15px",
      "height": "15px"
    },
    attrs: {
      "type": "checkbox",
      "id": "isBacklog"
    },
    domProps: {
      "checked": Array.isArray(_vm.isBacklogSelect) ? _vm._i(_vm.isBacklogSelect, null) > -1 : (_vm.isBacklogSelect)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isBacklogSelect,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isBacklogSelect = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isBacklogSelect = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isBacklogSelect = $$c
        }
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "name": "buttonBacklog"
    },
    on: {
      "click": _vm.saveBacklog
    }
  }, [_vm._v("Save")])])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "investigation"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitInvestigation($event)
      }
    }
  }, [(!_vm.formDisabled && _vm.investigationId) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "sectionHeaderRight"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": {
        path: '/SiteNumberRequest',
        query: {
          projectId: _vm.project.projectId,
          investigationId: _vm.investigationId
        }
      },
      "tag": "button"
    }
  }, [_vm._v("Site Number Request")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('investigation.reportTitle')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Report Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investigation.reportTitle),
      expression: "investigation.reportTitle"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "reportTitle",
      "placeholder": "Report Title",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.investigation.reportTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investigation, "reportTitle", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('investigation.reportTitle')),
      expression: "errors.has('investigation.reportTitle')"
    }],
    staticClass: "has-error"
  }, [_vm._v("\r\n                                " + _vm._s(_vm.reportTitleErrorMsg) + "\r\n                            ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "float": "right"
    }
  }, [_vm._v(_vm._s((_vm.investigation.reportTitle || '').length + '/255'))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Activities")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('checkBoxPanel', {
    ref: "activitiesCheckboxPanel",
    attrs: {
      "numColumns": 4,
      "lookupList": _vm.investigationActivities,
      "fieldName": 'activityTypeId',
      "name": "investigationActivitiesCB"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Survey Scope")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investigation.surveyScopeId),
      expression: "investigation.surveyScopeId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "surveyScopeId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.investigation, "surveyScopeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.surveyScopeList), function(surveyScope) {
    return _c('option', {
      key: surveyScope.surveyScopeId,
      domProps: {
        "value": surveyScope.surveyScopeId
      }
    }, [_vm._v("\r\n                                    " + _vm._s(surveyScope.description) + "\r\n                                ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('investigation.fieldworkStartDate') || _vm.errors.has('investigation.fieldworkEndDate')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Field Work Dates")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "MM/dd/yyyy",
      "placeholder": "Select Start Date",
      "disabled": _vm.formDisabled
    },
    model: {
      value: (_vm.investigation.fieldworkStartDate),
      callback: function($$v) {
        _vm.$set(_vm.investigation, "fieldworkStartDate", $$v)
      },
      expression: "investigation.fieldworkStartDate"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investigation.fieldworkStartDate),
      expression: "investigation.fieldworkStartDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "fieldworkStartDate",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.investigation.fieldworkStartDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investigation, "fieldworkStartDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("  TO   ")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "MM/dd/yyyy",
      "placeholder": "Select End Date",
      "disabled": _vm.formDisabled
    },
    model: {
      value: (_vm.investigation.fieldworkEndDate),
      callback: function($$v) {
        _vm.$set(_vm.investigation, "fieldworkEndDate", $$v)
      },
      expression: "investigation.fieldworkEndDate"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investigation.fieldworkEndDate),
      expression: "investigation.fieldworkEndDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "fieldworkEndDate",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.investigation.fieldworkEndDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investigation, "fieldworkEndDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('investigation.fieldworkStartDate')),
      expression: "errors.has('investigation.fieldworkStartDate')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Fieldwork Start Date is required")])]), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('investigation.fieldworkEndDate')),
      expression: "errors.has('investigation.fieldworkEndDate')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Fieldwork End Date is required")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Summary Results")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investigation.resultSummary),
      expression: "investigation.resultSummary"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "resultSummary",
      "placeholder": "Summary Results"
    },
    domProps: {
      "value": (_vm.investigation.resultSummary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investigation, "resultSummary", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Type of Sites Reported")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-label"
  }, [_vm._v("\r\n                            " + _vm._s(_vm.investigation.propertyTypes) + "\r\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Site Count")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-label"
  }, [_vm._v("\r\n                            " + _vm._s(_vm.siteCount) + "\r\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Isolated Resource Count")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-label"
  }, [_vm._v("\r\n                            " + _vm._s(_vm.isolateCount) + "\r\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Crew Chief(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investigation.crewCheifs),
      expression: "investigation.crewCheifs"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.investigation.crewCheifs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investigation, "crewCheifs", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Crew Members")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investigation.crewMembers),
      expression: "investigation.crewMembers"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Crew Members"
    },
    domProps: {
      "value": (_vm.investigation.crewMembers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investigation, "crewMembers", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Author")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.investigation.reportAuthor),
      expression: "investigation.reportAuthor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.investigation.reportAuthor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investigation, "reportAuthor", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (!_vm.beforeDateConversion) ? _c('div', {
    staticClass: "form-group"
  }, [_c('landOwnership', {
    attrs: {
      "parentId": _vm.investigationId,
      "source": "Investigation",
      "formDisabled": _vm.formDisabled
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.beforeDateConversion) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Investigation Area (in whole acres)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('table', {
    attrs: {
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "75px"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Intensive/Class III")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Extensive/Other")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Total")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Federal")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "125px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.investigation.acresFederalIntensive),
      expression: "investigation.acresFederalIntensive",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.investigation.acresFederalIntensive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investigation, "acresFederalIntensive", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "125px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.investigation.acresFederalExtensive),
      expression: "investigation.acresFederalExtensive",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.investigation.acresFederalExtensive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investigation, "acresFederalExtensive", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.addValues([_vm.investigation.acresFederalIntensive, _vm.investigation.acresFederalExtensive])))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Other Public")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.investigation.acresOtherPublicIntensive),
      expression: "investigation.acresOtherPublicIntensive",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.investigation.acresOtherPublicIntensive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investigation, "acresOtherPublicIntensive", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.investigation.acresOtherPublicExtensive),
      expression: "investigation.acresOtherPublicExtensive",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.investigation.acresOtherPublicExtensive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investigation, "acresOtherPublicExtensive", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.addValues([_vm.investigation.acresOtherPublicIntensive, _vm.investigation.acresOtherPublicExtensive])))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Private")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.investigation.acresPrivateIntensive),
      expression: "investigation.acresPrivateIntensive",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.investigation.acresPrivateIntensive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investigation, "acresPrivateIntensive", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.investigation.acresPrivateExtensive),
      expression: "investigation.acresPrivateExtensive",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.investigation.acresPrivateExtensive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.investigation, "acresPrivateExtensive", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.addValues([_vm.investigation.acresPrivateIntensive, _vm.investigation.acresPrivateExtensive])))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "25px"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.addValues([_vm.investigation.acresFederalIntensive, _vm.investigation.acresOtherPublicIntensive, _vm.investigation.acresPrivateIntensive])))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.addValues([_vm.investigation.acresFederalExtensive, _vm.investigation.acresOtherPublicExtensive, _vm.investigation.acresPrivateExtensive])))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("PLSS Location")]), _vm._v(" "), (!_vm.formDisabled) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "button3",
      "disabled": !_vm.investigation.investigationId
    },
    on: {
      "click": function($event) {
        _vm.$refs['plssLocationModal'].open()
      }
    }
  }, [_vm._v("Add PLSS Locations")]), _vm._v(" "), _c('modal', {
    ref: "plssLocationModal",
    attrs: {
      "title": "Add Sections(s)"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h4', [_vm._v("Add PLSS Locations")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('plssComponent', {
    ref: "plssComponent",
    attrs: {
      "showTitle": false
    },
    on: {
      "savePlss": _vm.savePlss
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$refs['plssLocationModal'].close()
      }
    }
  }, [_vm._v("Close")])])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Section List")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.plssLocationGridSpec.tableData,
      "columns": _vm.plssLocationGridSpec.columns,
      "options": _vm.plssLocationGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "delete",
      fn: function(props) {
        return !_vm.formDisabled ? [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deletePlssLocation(props.row.investigationPlssLocationId)
            }
          }
        })])] : undefined
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.serverErrorList.length > 0),
      expression: "serverErrorList.length > 0"
    }]
  }, [_c('span', {
    staticClass: "has-error"
  }, [_vm._v("Validation issues must be corrected prior to submit")]), _vm._v(" "), _c('ul', {
    staticClass: "has-error"
  }, _vm._l((_vm.serverErrorList), function(serverError) {
    return _c('li', {
      key: serverError.index
    }, [_vm._v(_vm._s(serverError))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.formDisabled) ? _c('div', {
    staticClass: "col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "disabled": _vm.saving || _vm.isLoading,
      "name": "buttonSubmit",
      "type": "submit"
    }
  }, [_vm._v("\r\n                                " + _vm._s(_vm.isNew ? 'Create' : 'Save') + "\r\n                            ")])]) : _vm._e()])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDebug),
      expression: "isDebug"
    }],
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("****** Debug ******")])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Investigation: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.investigation))]), _vm._v(" "), _c('h4', [_vm._v(" Error: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.serverErrorList))])])])], 1), _vm._v(" "), (!_vm.isClientUser) ? _c('tab', {
    attrs: {
      "header": "Documents",
      "disabled": _vm.isNew
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('investigationHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation),
      expression: "investigation"
    }],
    attrs: {
      "investigation": _vm.investigation
    }
  }), _vm._v(" "), _c('undertakingHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation && !_vm.isConsultantOnly),
      expression: "investigation && !isConsultantOnly"
    }],
    attrs: {
      "undertaking": _vm.undertaking
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(!_vm.isNew) ? _c('investigationDocuments', {
    ref: "documents",
    attrs: {
      "parentId": _vm.investigationId,
      "formDisabled": _vm.formDisabled && !_vm.shpoCrHasDoc,
      "loadOnMount": false,
      "isAdmin": _vm.isAdmin,
      "documentPermissions": _vm.documentPermissions
    },
    on: {
      "mediaRefreshComplete": function($event) {
        _vm.handleMediaRefreshComplete()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('hr'), _vm._v(" "), (!_vm.isNew) ? _c('mediaLetter', {
    ref: "mediaLetter",
    attrs: {
      "parentId": _vm.investigationId,
      "mediaTypeId": _vm.letterMediaTypeId,
      "loadOnMount": false
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('scantoolMedia', {
    ref: "scantoolMedia",
    attrs: {
      "investigationId": _vm.investigationId,
      "loadOnMount": false
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isClientUser && !_vm.isRestrictedRole) ? _c('tab', {
    attrs: {
      "header": "Map",
      "disabled": _vm.isNew || _vm.isLoading
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('investigationHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation),
      expression: "investigation"
    }],
    attrs: {
      "investigation": _vm.investigation
    }
  }), _vm._v(" "), _c('undertakingHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation && !_vm.isConsultantOnly),
      expression: "investigation && !isConsultantOnly"
    }],
    attrs: {
      "undertaking": _vm.undertaking
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('mapx', {
    ref: "mapx",
    attrs: {
      "mediaTypeId": _vm.mediaTypeId,
      "parentId": _vm.investigationId,
      "loadOnMount": false,
      "invDbNumber": _vm.invMapUseDbi
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isClientUser && !_vm.isRestrictedRole) ? _c('tab', {
    attrs: {
      "header": "Cultural Resource Selection",
      "disabled": _vm.isNew
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('investigationHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation),
      expression: "investigation"
    }],
    attrs: {
      "investigation": _vm.investigation
    }
  }), _vm._v(" "), _c('undertakingHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation && !_vm.isConsultantOnly),
      expression: "investigation && !isConsultantOnly"
    }],
    attrs: {
      "undertaking": _vm.undertaking
    }
  }), _vm._v(" "), _c('culturalResourceSelection', {
    ref: "crSelection",
    attrs: {
      "investigation": _vm.investigation,
      "formDisabled": _vm.formDisabled,
      "isQaqc": _vm.isPendingQaqc,
      "loadOnMount": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Site Summary / Submission",
      "disabled": _vm.isNew
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('investigationHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation),
      expression: "investigation"
    }],
    attrs: {
      "investigation": _vm.investigation
    }
  }), _vm._v(" "), _c('undertakingHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation && !_vm.isConsultantOnly),
      expression: "investigation && !isConsultantOnly"
    }],
    attrs: {
      "undertaking": _vm.undertaking
    }
  }), _vm._v(" "), _c('siteSummary', {
    ref: "siteSummary",
    attrs: {
      "id": "siteSummary",
      "isClientUser": _vm.isClientUser,
      "investigation": _vm.investigation,
      "loadOnMount": _vm.isRestrictedRole,
      "isConsultantOnly": _vm.isConsultantOnly,
      "isAdmin": _vm.isAdmin
    },
    on: {
      "workflowOnSubmitSuccess": _vm.workflowOnSubmitSuccess
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.isShpo) ? _c('quickLetter', {
    attrs: {
      "projectId": _vm.project.projectId,
      "investigationId": _vm.investigation.investigationId,
      "parentId": _vm.investigationId,
      "mediaTypeId": _vm.letterMediaTypeId
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.investigation.investigationId && !_vm.isClientUser) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.reportLoading,
      "name": "invSummaryReport"
    },
    on: {
      "click": _vm.genInvSummaryReport
    }
  }, [_vm._v("Generate Summary Report")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.reportLoading,
      "name": "invCoverReport"
    },
    on: {
      "click": _vm.genInvSummaryCoverReport
    }
  }, [_vm._v("Generate Cover Report")])]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Investigation")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ac2cdaf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Investigation.vue
// module id = 955
// module chunks = 1